// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_n2-0";
export var discountCodeInput = "_n2-1";